import { post } from '../Services/http';

export const ORDER_ARTICLE_FORM_SUBMIT = 'ORDER_ARTICLE_FORM_SUBMIT';
export const ORDER_ARTICLE_FORM_SUBMIT_DONE = 'ORDER_ARTICLE_FORM_SUBMIT_DONE';
export const ORDER_ARTICLE_FORM_SUBMIT_ERROR = 'ORDER_ARTICLE_FORM_SUBMIT_ERROR';
export const ORDER_ARTICLE_FORM_SET_ORDER_ARTICLE_FORM_DETAILS = 'ORDER_ARTICLE_FORM_SET_ORDER_ARTICLE_FORM_DETAILS';
export const ORDER_ARTICLE_FORM_SET_FILE_NAMES = 'ORDER_ARTICLE_FORM_SET_FILE_NAMES';

export const setOrderArticleFormDetails = (propName, value) => ({
    type: ORDER_ARTICLE_FORM_SET_ORDER_ARTICLE_FORM_DETAILS,
    payload: {
        key: 'orderArticleFormDetails',
        data: {
            [propName]: value
        }
    }
});

export const setFileNames = (fileNames) => ({
    type: ORDER_ARTICLE_FORM_SET_FILE_NAMES,
    payload: {
        key: 'orderArticleFormDetails',
        data: {
            ["fileNames"]: fileNames
        }
    }
});

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().orderArticleForm;
    return _submit('/api/orderarticleform', payload.orderArticleFormDetails, dispatch);
};

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then((response) => response.json())
        .then((result) => {
            dispatch(submitDone(result));
        })
        .catch((ex) => {
            if (ex.response) {
                ex.response.json().then((error) => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                });
            } else {
                dispatch(submitError(ex));
                dispatch(submitDone(null));
            }
        });
};

export const submitRequest = () => ({
    type: ORDER_ARTICLE_FORM_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: []
    }
});

export const submitDone = (result) => ({
    type: ORDER_ARTICLE_FORM_SUBMIT_DONE,
    payload: {
        result,
        isSubmitting: false
    }
});

export const submitError = (error) => ({
    type: ORDER_ARTICLE_FORM_SUBMIT_ERROR,
    payload: {
        error
    }
});
